import payableShipperReviewTranslations from '~/modules/payables-shipper-review/translations';
import payableTransporterReviewTranslations from '~/modules/payables-transporter-review/translations';
import payablePaymentStatementTranslations from '~/modules/payables-payment-statement/translations';
import transporterContractsTranslations from '~/modules/contract/translations';
import transporterTranslations from '~/modules/transporter/translations';
import {
  ALL_TRANSPORTER_FEE_TYPE,
  CONTRACT_SUPPLY_TYPE,
  FEE_REQUEST_STATUS,
  PAYABLE_ADJUSTMENT_FEE_TYPE,
  PAYABLE_ITEM_STATUS,
  PAYABLE_PAYMENT_SCHEME,
  PAYMENT_REQUEST_REJECTION_TYPE,
  SHIPPER_PAYMENT_REQUEST_REJECTION_TYPE,
  LICENSE_PLATE_TYPE,
  PAYMENT_REQUEST_STATUSES,
} from '~/modules/payment-request/constants';
import { DUE_STATUSES, SHIPPER_PAYABLE_STATUSES } from '~/modules/payables-shipper/constants';
import { PayableItemReviewStatusCategoryEnum } from '~/graphql/__generated__/operations/ltms';

const DICTIONARIES = {
  en: {
    account_bank_holder: 'Account Bank Holder',
    account_owner: 'Account Owner',
    account_type: 'Account Type',
    action: 'Action',
    action_status: 'Action Status',
    actual_amount: 'Actual Amount',
    actual_payable: 'Actual Payable',
    add_documents: 'Add Documents',
    add_input: 'Add Input',
    additional_documents: 'Additional Documents',
    adjustment: 'Adjustment',
    adjustment_amount: 'Adjustment Amount',
    adjustment_details: 'Adjustment Details',
    adjustment_included: 'Adjustment Included',
    adjustment_s: 'Adjustment/s',
    adjustment_type: 'Adjustment Type',
    adjustments: 'Adjustments',
    amount: 'Amount',
    amount_on_hold: 'Amount On Hold',
    amount_payable: 'Amount Payable',
    approve: 'Approve',
    approved: 'Approved',
    arrived_at_hub: 'Arrived At Hub',
    cancel_x: 'Cancel {{x}}',
    cancelled: 'Cancelled',
    cancellation_reason: 'Cancellation Reason',
    cancellation_reason_category: {
      [PayableItemReviewStatusCategoryEnum.NotExceed_13Days]: 'Not Exceed 13 Days',
      [PayableItemReviewStatusCategoryEnum.DeductFromTip]: 'Deduct from TIP',
      [PayableItemReviewStatusCategoryEnum.NoTip]: 'No TIP',
      [PayableItemReviewStatusCategoryEnum.ContractTermination]: 'Contract Termination',
      [PayableItemReviewStatusCategoryEnum.Other]: 'Other',
    },
    claims: 'Claims',
    cod_fee: 'COD Fee',
    collected: 'Collected',
    collected_amount: 'Collected Amount',
    complete_status: 'Complete Status',
    contract_code: transporterContractsTranslations.en.code,
    contract_period: 'Contract Period',
    contract_supply_type: {
      [CONTRACT_SUPPLY_TYPE.ALL_IN]: 'All-In',
      [CONTRACT_SUPPLY_TYPE.DRIVER_ONLY_RENTAL]: 'Driver-only Rental',
      [CONTRACT_SUPPLY_TYPE.FLEET_ONLY_RENTAL]: 'Fleet-only Rental',
      [CONTRACT_SUPPLY_TYPE.FLEET_AND_DRIVER_RENTAL]: 'Fleet and Driver Rental',
    },
    contract_termination: 'Contract Termination',
    contract_type: transporterContractsTranslations.en.type,
    create_payment_request: 'Create Payment Request',
    created_on_x_by_y: 'Created on {{x}} by {{y}}',
    destination: 'Destination',
    destination_x: 'Destination {{x}}',
    details: 'Details',
    disburse_amount: 'Disburse Amount',
    disbursed: 'Disbursed',
    disbursed_date: 'Disbursed Date',
    disbursed_to_shipper: 'Disbursed to Shipper',
    disbursement_failed: 'Disbursement Failed',
    driver_name: 'Driver Name',
    do_id: 'DO Number',
    do_list: 'DO List',
    do_on_hold: 'DO on hold',
    do_shipment_status: 'DO Shipment Status',
    downtime: 'Downtime',
    dsp_link: 'Disburse to Shipper Link',
    due_status: 'Due Status',
    due_status_info_map: {
      [DUE_STATUSES.OVERDUE]: 'Total Delivery Orders that have passed its payment schedule',
      [DUE_STATUSES.UPCOMING]: 'Total Delivery Orders that you need to process today',
    },
    due_status_map: {
      [DUE_STATUSES.COMPLETED]: 'Completed',
      [DUE_STATUSES.NOT_DUE_STATUS]: 'Not Due',
      [DUE_STATUSES.OVERDUE]: 'Overdue',
      [DUE_STATUSES.UPCOMING]: 'Upcoming',
    },
    expected_amount: 'Expected Amount',
    email: 'Email',
    elapsed_time_max: '> 72 hours',
    format_hours__mins_moment: 'H [hours] m [mins]',
    fee_request_status: {
      [FEE_REQUEST_STATUS.NOT_DUE]: 'Not Due',
      [FEE_REQUEST_STATUS.NEEDS_REVIEW]: 'Needs Review',
      [FEE_REQUEST_STATUS.HOLD]: 'Hold',
      [FEE_REQUEST_STATUS.CANCELLED]: 'Cancelled',
      [FEE_REQUEST_STATUS.REVIEWED]: 'Reviewed',
      [FEE_REQUEST_STATUS.REQUESTED]: 'Requested',
      [FEE_REQUEST_STATUS.FINANCE_ON_HOLD]: 'Finance On Hold',
      [FEE_REQUEST_STATUS.FINANCE_APPROVED]: 'Finance Approved',
      [FEE_REQUEST_STATUS.FINANCE_REJECTED]: 'Finance Rejected',
      [FEE_REQUEST_STATUS.FINANCE_CANCELLED]: 'Finance Cancelled',
      [FEE_REQUEST_STATUS.PROCESSING]: 'Processing',
      [FEE_REQUEST_STATUS.APPROVE]: 'Approved',
      [FEE_REQUEST_STATUS.DISBURSED]: 'Paid',
      [FEE_REQUEST_STATUS.DISBURSEMENT_FAILED]: 'Disbursement Failed',
      [FEE_REQUEST_STATUS.REQUEST_APPROVED]: 'Request Approved',
      [FEE_REQUEST_STATUS.REQUEST_REJECTED]: 'Request Rejected',
      [FEE_REQUEST_STATUS.REQUEST_SENT]: 'Request Sent',
    },
    fee_type: 'Fee Type',
    file_link: 'File Link',
    final_collected_amount: 'Final Collected Amount',
    finance_approved: 'Finance Approved',
    finance_cancelled: 'Finance Cancelled',
    finance_on_hold: 'Finance on Hold',
    forward_email: 'Forward Email',
    fleet_period: 'Fleet Period',
    generate_time_of_pdf: 'The PDF document was generated on {{x}}. Page PAGE_NUM of TOTAL_PAGES',
    grand_total: 'Grand Total',
    hold_reason: 'Hold Reason',
    hold_reason_category: {
      [PayableItemReviewStatusCategoryEnum.NotYetPaymentSchedule]: 'Not yet Payment Schedule',
      [PayableItemReviewStatusCategoryEnum.NeedMoreInformation]: 'Need More Information',
      [PayableItemReviewStatusCategoryEnum.InvoiceSent]: 'Invoice Sent',
      [PayableItemReviewStatusCategoryEnum.WaitingInvoiceRevision]: 'Waiting for Invoice Revision',
      [PayableItemReviewStatusCategoryEnum.Other]: 'Other',
    },
    hold: 'Hold',
    incomplete_reason: 'Incomplete Reason',
    input_shipper_payables: 'Input Shipper Payables',
    input_x: 'Input {{x}}',
    insert_field: 'Insert {{field}}',
    insurance: 'Insurance',
    internal_notes: 'Internal Notes',
    internal_notes_optional: 'Internal Notes (Optional)',
    last_updated: 'Last Updated',
    last_updated_by_x_y: 'Last updated by {{x}}, {{y}} WIB',
    last_updated_on_x_by_y: 'Last Updated on {{x}} by {{y}}',
    license_plate: 'License Plate',
    license_plate_type_map: {
      [LICENSE_PLATE_TYPE.YELLOW_PLATE]: 'Yellow',
      [LICENSE_PLATE_TYPE.BLACK_PLATE]: 'Black',
    },
    link_file_upload: 'Link File Upload',
    location_fees: 'Location Fees',
    manage_files: 'Manage Files',
    mark_request_as: 'Mark Request As',
    needs_review: 'Needs Review',
    no_abbr: 'No.',
    no_account: 'No Account',
    non_pkp: 'Non PKP',
    not_due: 'Not Due',
    notes_optional: 'Notes (Optional)',
    notes: 'Notes',
    npwp: 'NPWP',
    oncall_payable_payment_stage: {
      pod_stage_100: 'POD Stage - 100%',
      pod_stage_50: 'POD Stage - 50%',
      pol_stage_50: 'POL Stage - 50%',
    },
    on_hold: 'On Hold',
    other_adjustment: 'Other Adjustment',
    payment_schedule: 'Payment Schedule',
    pod: 'POD',
    pol: 'POL',
    pot: 'POT',
    payable_adjustment_fee_type_map: {
      [PAYABLE_ADJUSTMENT_FEE_TYPE.DOWNTIME]: 'Downtime',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.UNFULFILLED]: 'Unfulfilled',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.CLAIMS]: 'Claims',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.INSURANCE]: 'Insurance',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.PENALTY]: 'Penalty',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.PRICE]: 'Price Adjustment',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.OTHER]: 'Other Adjustment',
      [PAYABLE_ADJUSTMENT_FEE_TYPE.CONTRACT_TERMINATION]: 'Contract Termination',
    },
    payable_item_status: {
      [PAYABLE_ITEM_STATUS.APPROVE]: 'Approved',
      [PAYABLE_ITEM_STATUS.HOLD]: 'Hold',
    },
    payable_payment_scheme: {
      [PAYABLE_PAYMENT_SCHEME.PAYMENT_SCHEME_100]: '100',
      [PAYABLE_PAYMENT_SCHEME.PAYMENT_SCHEME_25_25_25_25]: '25-25-25-25',
      [PAYABLE_PAYMENT_SCHEME.PAYMENT_SCHEME_50_50]: '50-50',
      [PAYABLE_PAYMENT_SCHEME.PAYMENT_SCHEME_50_50_TIP]: '50-50_TIP',
    },
    payable_submitted_successfully: 'Payable submitted successfully',
    payment_action: 'Payment Action',
    payment_request_created_successfully: 'Payment request created successfully',
    payment_request_rejection_type_map: {
      [PAYMENT_REQUEST_REJECTION_TYPE.INVOICE_PROBLEM]: 'Invoice Problem',
      [PAYMENT_REQUEST_REJECTION_TYPE.DELIVERY_ORDER_PROBLEM]: 'Delivery Order Problem',
      [PAYMENT_REQUEST_REJECTION_TYPE.REQUEST_FROM_AP]: 'Request From AP',
      [SHIPPER_PAYMENT_REQUEST_REJECTION_TYPE.REQUEST_FROM_AR]: 'Request From AR',
      [SHIPPER_PAYMENT_REQUEST_REJECTION_TYPE.OTHER]: 'Other',
    },
    payment_request_submit: 'Payment Request submit successfully',
    payment_scheme: transporterTranslations.en.payment_scheme,
    payment_stage: 'Payment Stage',
    payment_statement: payablePaymentStatementTranslations.en,
    penalty: 'Penalty',
    pkp: 'PKP',
    pot_link: 'POT Link',
    pr_details: 'PR Details',
    pr_number: 'PR Number',
    preview_payment_request: 'Preview Payment Request',
    price_adjustment: 'Price Adjustment',
    price_decrease_adjustment: 'Price Decrease Adjustment',
    price_increase_adjustment: 'Price Increase Adjustment',
    processing: 'Processing',
    profile_name: 'Profile Name',
    project_name: 'Project Name',
    project_type: 'Project Type',
    projected_payment_statement: 'Projected Payment Statement',
    proof_of_delivery: 'Proof of Delivery',
    proof_of_loading: 'Proof of Loading',
    proof_of_transfer: 'Proof of Transfer',
    reason: 'Reason',
    remove_do: 'Remove DO',
    rejected: 'Rejected',
    reject_x: 'Reject {{x}}',
    rejection_type: 'Rejection Type',
    request_type: 'Request Type',
    requested: 'Requested',
    requested_amount: 'Requested Amount',
    remove_document: 'Remove Document',
    resync_awb: 'Resync AWB',
    review_shipper_payables: 'Review Shipper Payables',
    review_status: 'Review Status',
    review_status_summary_info: 'Numbers shows all-time Delivery Order',
    review_summary: 'Review Summary',
    review_transporter_payables: 'Review Transporter Payables',
    review: 'Review',
    review_x: 'Review {{x}}',
    reviewed: 'Reviewed',
    revise: 'Revise',
    route_type: 'Route Type',
    second_attempt: 'Second Attempt',
    see_details: 'See Details',
    see_docs: 'See Docs',
    select_do_for_pr: 'Select DO for Payment Request',
    select_rejection_type: 'Select Rejection Type',
    select_shipments_to_continue: 'Select Shipments to Continue',
    select_transporter_for_review: 'Select Transporter for Review',
    select_vcc_for_pr: 'Select Vehicle Contract Code for Payment Request',
    selection_coachmark: {
      checkbox: 'Don\'t show this next time',
      check_same_x: 'Tick Checkbox with same {{x}}',
      okText: 'I got it',
      title: 'Review Tips',
    },
    share_payment_statement: 'Share Payment Statement',
    shipment_date: 'Shipment Date',
    shipment_information: 'Shipment Information',
    shipper_details: 'Shipper Details',
    shipper_disbursement: 'Shipper Disbursement',
    shipper_name: 'Shipper Name',
    shipper_payable_status_map: {
      [SHIPPER_PAYABLE_STATUSES.ARRIVED_AT_HUB]: 'Arrived At Hub',
      [SHIPPER_PAYABLE_STATUSES.NEEDS_REVIEW]: 'Needs Review',
      [SHIPPER_PAYABLE_STATUSES.HOLD]: 'Hold',
      [SHIPPER_PAYABLE_STATUSES.REVIEWED]: 'Reviewed',
      [SHIPPER_PAYABLE_STATUSES.REQUESTED]: 'Requested',
      [SHIPPER_PAYABLE_STATUSES.FINANCE_APPROVED]: 'Finance Approved',
      [SHIPPER_PAYABLE_STATUSES.FINANCE_CANCELLED]: 'Finance Cancelled',
      [SHIPPER_PAYABLE_STATUSES.FINANCE_ON_HOLD]: 'Finance on Hold',
      [SHIPPER_PAYABLE_STATUSES.PROCESSING]: 'Processing',
      [SHIPPER_PAYABLE_STATUSES.DISBURSED]: 'Disbursed',
      [SHIPPER_PAYABLE_STATUSES.DISBURSEMENT_FAILED]: 'Disbursement Failed',
    },
    shipper_review: payableShipperReviewTranslations.en,
    skb: 'SKB',
    stage: 'Stage',
    supply_type: transporterTranslations.en.supply_type,
    table_selection_banner_subtitle: {
      shipper: 'Actual amount of {{actualAmount}} out of {{estimatedAmount}}',
    },
    table_selection_banner_title: {
      shipper: '{{count}} Shipments from {{shipperName}} - {{projectName}} - {{date}} has been selected',
      dedicated: '{{count}} Vehicle Contract Code has been selected',
      oncall: '{{count}} DOs has been selected',
    },
    tax_status: {
      [PAYMENT_REQUEST_STATUSES.APPROVED]: 'Finance Approved',
      [PAYMENT_REQUEST_STATUSES.ON_HOLD]: 'Finance On Hold',
      [PAYMENT_REQUEST_STATUSES.REJECTED]: 'Finance Rejected',
      [PAYMENT_REQUEST_STATUSES.CANCELLED]: 'Finance Cancelled',
      [PAYMENT_REQUEST_STATUSES.PROCESSING]: 'Processing',
      [PAYMENT_REQUEST_STATUSES.DISBURSED]: 'Paid',
      [PAYMENT_REQUEST_STATUSES.DISBURSEMENT_FAILED]: 'Disbursement Failed',
    },
    tip_fee: 'TIP Fee',
    total_amount_summary_info: 'Total Collected and Requested shows amount that has been reviewed',
    total_collected_amount_today: 'Total Collected Amount Today',
    total_payment: 'Total Payment',
    total_requested_amount_today: 'Total Requested Amount Today',
    transporter_fee_type_map: {
      [ALL_TRANSPORTER_FEE_TYPE.SHIPMENT_FEE]: 'Shipment Fee',
      [ALL_TRANSPORTER_FEE_TYPE.RENT_FEE]: 'Rent Fee',
      [ALL_TRANSPORTER_FEE_TYPE.COD_FEE]: 'COD Fee',
      [ALL_TRANSPORTER_FEE_TYPE.CLAIMS]: 'Claims',
      [ALL_TRANSPORTER_FEE_TYPE.PENALTY]: 'Penalty',
      [ALL_TRANSPORTER_FEE_TYPE.INSURANCE]: 'Insurance',
      [ALL_TRANSPORTER_FEE_TYPE.PRICE]: 'Price Adjustment',
      [ALL_TRANSPORTER_FEE_TYPE.OTHER]: 'Other Adjustment',
      [ALL_TRANSPORTER_FEE_TYPE.TIP_FEE]: 'Tip Fee',
      [ALL_TRANSPORTER_FEE_TYPE.CONTRACT_TERMINATION]: 'Contract Termination',
      [ALL_TRANSPORTER_FEE_TYPE.DOWNTIME]: 'Downtime',
      [ALL_TRANSPORTER_FEE_TYPE.UNFULFILLED]: 'Unfulfilled',
    },
    transporter_profile: 'Transporter Profile',
    transporter_review: payableTransporterReviewTranslations.en,
    unfulfilled: 'Unfulfilled',
    vcc_period: 'VCC Period',
    vehicle_contract_code: 'Vehicle Contract Code',
    view_do_list: 'View DO List',
    view_documents: 'View Documents',
    yes_cancel_request: 'Yes, Cancel Request',
    yes_hold_request: 'Yes, Hold Request',
    yes_reject_request: 'Yes, Reject Request',
    x_hours_x_mins: '{{x}} hours {{y}} mins',
    x_payment: '{{x}} Payment',
    x_payment_item: '{{x}} Payment Item',
    x_shipments_x_Locations: '{{x}} Shipments - {{y}} Locations',
  },
};

export default DICTIONARIES;
